<div class="filters-grid" [formGroup]="formGroup">
  <mat-form-field appearance="outline">
    <mat-label>{{ 'Company' | translate }}</mat-label>
    <input
      matInput
      formControlName="company"
      [placeholder]="'Company' | translate"
      [matAutocomplete]="autocompleteCompany"
      [errorStateMatcher]="matcher"
      tabindex="1"
    />
    <mat-autocomplete #autocompleteCompany="matAutocomplete" [displayWith]="displayValue">
      @for (company of companies$ | async; track company) {
      <mat-option [value]="company"> {{ company.Name }} </mat-option>
      }
    </mat-autocomplete>
  </mat-form-field>

  <mat-form-field appearance="outline">
    <mat-label>{{ 'Employer' | translate }}</mat-label>
    <input matInput formControlName="employer" placeholder="{{ 'Employer' | translate }}" [matAutocomplete]="autocompleteEmployer" tabindex="2" />
    <mat-autocomplete #autocompleteEmployer="matAutocomplete" [displayWith]="displayValue">
      @for (employer of employers$ | async; track employer) {
      <mat-option [value]="employer">
        {{ employer.Name }}
      </mat-option>
      }
    </mat-autocomplete>
  </mat-form-field>

  <mat-form-field appearance="outline">
    <mat-label>{{ 'EmployerObject' | translate }}</mat-label>
    <input
      matInput
      formControlName="employerObject"
      placeholder="{{ 'EmployerObject' | translate }}"
      [matAutocomplete]="autocompleteEmployerObject"
      tabindex="3"
    />
    <mat-autocomplete #autocompleteEmployerObject="matAutocomplete" [displayWith]="displayValue">
      @for (employerObject of employerObjects$ | async; track employerObject) {
      <mat-option [value]="employerObject">
        {{ employerObject.Name }}
      </mat-option>
      }
    </mat-autocomplete>
  </mat-form-field>

  <mat-form-field appearance="outline">
    <mat-label>{{ 'Pesel' | translate }}</mat-label>
    <input matInput type="text" formControlName="pesel" tabindex="4" />
  </mat-form-field>

  <mat-form-field appearance="outline">
    <mat-label>{{ 'LastName' | translate }}</mat-label>
    <input matInput type="text" formControlName="lastName" tabindex="5" />
  </mat-form-field>

  <mat-form-field appearance="outline">
    <mat-label>{{ 'FirstName' | translate }}</mat-label>
    <input matInput type="text" formControlName="firstName" tabindex="6" />
  </mat-form-field>

  <mat-form-field appearance="outline">
    <mat-label>{{ 'AbsenceType' | translate }}</mat-label>
    <mat-select formControlName="absenceTypeId" multiple tabindex="7">
      @for (absenceType of absenceTypes$ | async; track absenceType) {
      <mat-option [value]="absenceType.Id">
        {{ absenceType.Name }}
      </mat-option>
      }
    </mat-select>
  </mat-form-field>

  <mat-form-field appearance="outline">
    <mat-label>{{ 'Status' | translate }}</mat-label>
    <mat-select formControlName="statusId" multiple tabindex="8">
      @for (absenceStatus of absenceStatuses$ | async; track absenceStatus) {
      <mat-option [value]="absenceStatus.Id">
        {{ absenceStatus.Name }}
      </mat-option>
      }
    </mat-select>
  </mat-form-field>

  <mat-form-field appearance="outline">
    <mat-label>{{ 'AbsenceStartDate' | translate }}</mat-label>
    <input matInput [matDatepicker]="startDatePicker" formControlName="startDate" autocomplete="date" tabindex="9" />
    <mat-datepicker-toggle [for]="startDatePicker" matSuffix></mat-datepicker-toggle>
    <mat-datepicker #startDatePicker></mat-datepicker>
  </mat-form-field>

  <mat-form-field appearance="outline">
    <mat-label>{{ 'AbsenceEndDate' | translate }}</mat-label>
    <input matInput [matDatepicker]="endDatePicker" formControlName="endDate" autocomplete="date" tabindex="10" />
    <mat-datepicker-toggle [for]="endDatePicker" matSuffix></mat-datepicker-toggle>
    <mat-datepicker #endDatePicker></mat-datepicker>
  </mat-form-field>

  <mat-form-field appearance="outline">
    <mat-label>{{ 'Absences.List.WorkingTimeDimensionFilter' | translate }}</mat-label>
    <mat-select formControlName="workingTimeDimension" multiple tabindex="11">
      @for (dimension of workingTimeDimensions$ | async; track dimension) {
      <mat-option [value]="dimension">
        {{ dimension }}
      </mat-option>
      }
    </mat-select>
  </mat-form-field>

  <mat-form-field appearance="outline">
    <mat-label>{{ 'Absences.List.ActiveAgreementFilter' | translate }}</mat-label>
    <mat-select formControlName="activeAgreement" tabindex="12">
      <mat-option [value]="true">{{ 'Absences.List.Yes' | translate }}</mat-option>
      <mat-option [value]="false">{{ 'Absences.List.No' | translate }}</mat-option>
    </mat-select>
  </mat-form-field>

  <mat-form-field appearance="outline" *hasPermission="isSentToExteralSystemPermissions">
    <mat-label>{{ 'IsSentToExteralSystem' | translate }}</mat-label>
    <mat-select formControlName="absenceSyncStatusId" multiple tabindex="13">
      @for (absenceSyncStatus of absenceSyncStatuses$ | async; track absenceSyncStatus) {
      <mat-option [value]="absenceSyncStatus.Id">
        {{ absenceSyncStatus.Name }}
      </mat-option>
      }
    </mat-select>
  </mat-form-field>

  <div class="year-filter">
    <span class="year-filter__label">{{ 'Absences.List.YearFilter' | translate }}:</span>
    <app-year-picker [year]="currentYear" (yearChange)="onYearChange($event)"></app-year-picker>
  </div>

  <mat-form-field appearance="outline" class="subordinates-field">
    <mat-label>{{ 'AppliesToSubordinates' | translate }}</mat-label>
    <mat-select formControlName="subordinates" multiple tabindex="14">
      @for (option of subordinateOptions; track option.Id) {
      <mat-option [value]="option.Id">
        {{ option.Name }}
      </mat-option>
      }
    </mat-select>
  </mat-form-field>
</div>
